import { Injectable } from '@angular/core';
import { Observable, observable, Subject } from 'rxjs';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { config } from '../config';
import { Console } from 'console';
import { ConstructionL1Component } from '../courses-layouts/construction-l1/construction-l1.component';
@Injectable({
  providedIn: 'root'
})
export class AccidentService {


  private editAccidentUser = new Subject<any>();
  public accidentLength = new Subject<any>();

  constructor(private http: HttpClient) { }


  addAccident(data: any, files: any): Observable<any> {
    data['files'] = files
    console.log("Adding clients", data);
    return new Observable<any>((observer) => {
      console.log("Observable");
      var that = this;
      this.http.post(config.baseApiUrl + "accident", data).subscribe((res: any) => {

        observer.next(res);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })

    });

  }





  getAccidents(): Observable<any> {
    console.log('accident get list work')
    // console.log("Adding clients", id);


    var that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "accident").subscribe((res: any) => {
        console.log("Get Courses : ", res);
        observer.next(res);
      }, (err) => {
        observer.error(err)
      }, () => {
        observer.complete();
      })
    });

  }


  getSystemTime(): Observable<any> {
    console.log('accident get list work')
    // console.log("Adding clients", id);


    var that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "time-log/systemDate").subscribe((res: any) => {
        console.log("Get Courses : ", res);
        observer.next(res);
      }, (err) => {
        observer.error(err)
      }, () => {
        observer.complete();
      })
    });

  }




  getAccident(id): Observable<any> {
    // if (!id) {
    //   return;
    // } 

    console.log("Getting Accident single");
    var that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "accident?_id=" + id).subscribe((res: any) => {
        console.log("Get Single : ", res);
        observer.next(res.data);
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })
    });
  }


  editAccident(data): Observable<any> {
    // console.log("data---->",data,"files--->",files);
    // data['files'] = files
    console.log("data---->", data);
    return new Observable<any>((observer) => {
      console.log('edit data', data)
      console.log("Observable");
      this.http.put(config.baseApiUrl + "accident", data).subscribe((res: any) => {
        console.log("Edited Accident : ", res);
        observer.next(res);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })
    });
  }



  getLastAccident() {


    return new Observable<any>((observer) => {
      console.log("Observable");
      var that = this;
      this.http.get(config.baseApiUrl + "accident/last-accident").subscribe((res: any) => {

        observer.next(res.data);
        console.log('response next...')
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })

    });


  }


  deleteAccident(id): Observable<any> {
    return new Observable<any>((observer) => {
      console.log('delte data', id)
      console.log("Observable");
      this.http.delete(config.baseApiUrl + "accident?_id=" + id).subscribe((res: any) => {
        console.log("Delete Accident : ", res);
        observer.next(res);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })
    });
  }





  // Accident User API

  getAccidentUser(data): Observable<any> {
    console.log("Adding data accident", data);
    let newdata = {}
    newdata['email'] = data.email;
    newdata['accidentId'] = data.accidentId
    return new Observable<any>((observer) => {
      console.log("Observable");
      var that = this;
      this.http.post(config.baseApiUrl + "accident/user-list", newdata).subscribe((res: any) => {

        observer.next(res.data);
        console.log('response next...')
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })

    });

  }



  /** ******************************************************************
   * add useraccident 
   */

  addAccidentUser(data) {


    return new Observable<any>((observer) => {
      console.log("Observable");
      var that = this;
      this.http.post(config.baseApiUrl + "accident/add-user", data).subscribe((res: any) => {

        observer.next(res.data);
        console.log('response next...')
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })

    });


  }




  addExistingUserInAccident(data) {


    return new Observable<any>((observer) => {
      console.log("Observable");
      var that = this;
      this.http.post(config.baseApiUrl + "accident/multiple-user", data).subscribe((res: any) => {

        observer.next(res.data);
        console.log('response next...')
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })

    });


  }

  // Get accident list by User ID
  getAccidentByUserId(id) {
    console.log("Get accident by userId", id);
    return new Observable<any>((observer) => {
      console.log("Observable");
      var that = this;
      this.http.get(config.baseApiUrl + "accident/user?userId=" + id).subscribe((res: any) => {

        observer.next(res.data.data);
        console.log('response next...')
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })

    });

  }

  editAccidentUserData(obj) {
    this.editAccidentUser.next(obj)
  }


  editUserObservable(): Observable<any> {
    return this.editAccidentUser.asObservable();
  }


  displayAccidentTab(data) {
    console.log("here is the data of accident tab closed",data)
    this.accidentLength.next(data)

  }
  displayAccidentTabObservable(): Observable<any> {
    return this.accidentLength.asObservable();
  }


}
